import { ApplicationType } from "./ApplicationType";

export class DeviceSession {
    multiplayerSessionId?: string;
    deviceSessionId!: string;
    applicationType!: ApplicationType;
    timestamp!: Date;
    userId!: string;
    wentOnlineTime!: Date;
}